import { configureStore } from '@reduxjs/toolkit';
import usersReducer from './slices/usersSlice';
import lakesReducer from './slices/lakesSlice';

export const store = configureStore({
  reducer: {
    users: usersReducer,
    lakes: lakesReducer,
  },
});

export default store;
